import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

@Component({
  selector: 'sn-name',
  templateUrl: './name-dialog.component.html',
  styleUrls: ['./name-dialog.component.scss'],
})
export class FsInputDialogComponent implements OnInit {
  public title: string;
  public form = new UntypedFormGroup({});
  public key: string = 'name';
  public submitButton: string = t('common.save');
  public cancelButton: string = t('common.cancel');
  public label: string = t('common.name');
  public placeholder: string = t('common.enterName');
  public formModel: any = {};
  public formFields: SnFormFieldConfig[];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly _dialogRef: MatDialogRef<FsInputDialogComponent>,
  ) {
    this.title = this.data.title ? this.data.title : t('common.enterName');
    this.submitButton = this.data.submitButton || this.submitButton;
    this.cancelButton = this.data.cancelButton || this.cancelButton;
    this.key = this.data.key || this.key;
    this.label = this.data.label || this.label;
    this.placeholder = this.data.placeholder || this.placeholder;
    this.formModel = this.data.formModel || this.formModel;
  }

  public ngOnInit(): void {
    this.setForm();
    if (this.data.formModel) {
      this.formModel = { ...this.formModel };
    }
  }

  public submitForm(): void {
    this._dialogRef.close(this.formModel);
  }

  public setForm(): void {
    this.formFields = [
      {
        key: this.key,
        type: 'input',
        templateOptions: {
          label: this.label,
          placeholder: this.placeholder,
          required: true,
        },
      },
    ];
  }
}
